<template>
  <el-container style="height: 100%">
    <!-- :class="{ collapse_menu: showCollapseMenu }" -->
    <el-aside width="200px">
      <div class="main-title">
        <span>中公教育</span>后台
        <i class="el-icon-menu" @click="postMessage('showNavList')"></i>
      </div>
      <p class="my_collection">我的收藏</p>
      <!-- <p class="my_collection" v-if="!showCollapseMenu">我的收藏</p> -->
      <!-- <p class="my_collection" v-else>收藏</p> -->
      <div class="collection_nav" v-if="network && userConfig && userConfig.config && userConfig.config.length>0">
        <draggable v-model="userConfig.config" @update="datadragEnd" :options="{animation:200}">
          <p v-for="item in userConfig.config" :key="item.url" @click="goNav(item)" :class="{'active':item.url == activeNavUrl}">
            <el-tooltip
              :disabled="true"
              class="item"
              effect="dark"
              :content="item.menuName"
              placement="top-start"
            >
              <span class="nav_text">{{ item.menuName }}</span>
            </el-tooltip>
            <span class="menu_group">
              <i
                class="edit_collection_nav el-icon-edit"
                @click.stop="editNavName(item)"
              ></i>
              <i class="del_collection_nav el-icon-close" @click.stop="delNav(item)"></i>
            </span>
          </p>
        </draggable>
      </div>
      <div class="no_collection" v-if="network && userConfig && userConfig.config && userConfig.config.length == 0 && presetConfigList.length > 0">
        <p>请自定义导航内容<br />或选择你的角色</p>
        <div class="recommend_nav">
          <div v-for="item in presetConfigList" :key="item.id" @click="setPresetConfig(item.config)">{{item.name}}</div>
        </div>
      </div>
      <div class="network_error" v-if="!network">
        <p>网络错误,点击重试</p>
        <span class="el-icon-refresh-right" @click="GetUserConfig()"></span>
      </div>
      <div class="aside_menu">
        <!-- <span @click="showCollapseMenu = !showCollapseMenu" class="collapse_btn">
          <i class="el-icon-s-fold" v-if="!showCollapseMenu"></i>
          <i class="el-icon-s-unfold" v-else></i>
          收起</span
        > -->
        <span @click="postMessage('showSystemNav')">
          <i class="el-icon-sort"></i>
          系统导航</span
        >
      </div>
    </el-aside>
    <el-container>
      <el-header style="background-color: #fff; border-bottom: 1px solid #eee; ">
        <el-row
          type="flex"
          class="row-bg"
          justify="space-between"
          align="middle"
        >
          <el-col :span="3" :offset="21">
            <!-- <span><span style="font-weight:700">{{ name }}</span>&nbsp;&nbsp;&nbsp;<span class="quit-system" @click="quitSystem()">退出</span></span> -->
            <el-dropdown>
              <span class="el-dropdown-link">
                <span style="font-weight: 700; font-size: 16px; cursor: pointer"
                  >{{ name }}<i class="el-icon-arrow-down el-icon--right"></i
                ></span>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <span @click="quitSystem">
                    退出登录
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-header>
      <el-main class="main-content">
        <router-view></router-view>
      </el-main>
    </el-container>
    <edit-nav-alias
      :nav-config="navConfig"
      :show-edit="showEditBox"
      @handleCancle="handleCancel"
      @handleConfirm="handleConfirm"
    ></edit-nav-alias>
  </el-container>
</template>
<script>
// import global_ from '../../global/index.js'
import draggable from 'vuedraggable';
import axios from 'axios';
import store from '@/store/index';
import { mapGetters, mapActions } from 'vuex';
import { getUserInfo } from '@/api/interface-user';
export default {
  name: "Index",
  data() {
    return {
      name: "",
      myCollectionNav: [
        { name: "商品管理", link: "" },
        { name: "电商订单管理", link: "" },
        { name: "订单改价", link: "" },
        { name: "订单查询", link: "" },
        { name: "物流跟踪", link: "" },
      ],
      networkIsError: false,
      // showCollapseMenu: false,
      navConfig:{},
      showEditBox: false,
      activeNavUrl:'',
      network:true
    };
  },
  components:{
    draggable
  },
  computed: {
    ...mapGetters(['presetConfigList','userConfig','platformList']),
  },
  mounted() {
    sso.event("logged",user => {
      this.name = user.getUsername();
    });
    this.GetUserConfig();
    this.listenMessage();
    this.postMessage('getTopLocation');
  },
  methods: {
    ...mapActions(['GetUserConfig','saveUserConfig','delUserConfig']),
    // 拖动排序 回调
    async datadragEnd(evt){
      evt.preventDefault();
      let config = this.userConfig.config;
      let newConfig = await config.map((item,i)=>{
        return {
          menuId:item.menuId,
          menuName:item.menuName,
          platformId:item.platformId,
          platformShopId:item.platformShopId,
          url:item.url,
          sort:config.length - i - 1
        };
      });
      this.saveUserConfig(newConfig).then(res=>{
      })
    },
    goNav(item){
      // let testUrl = `http://localhost:8081/#/eduStudyPackageManage?id=1&from=${encodeURIComponent(item.url)}`;

      // if(top.location == self.location){
      //   window.open(testUrl,'_self');
      // }else{
      //   top.location.replace(testUrl);
      // }
      // iip系统 参数不带id=1 会重新刷新页面
      this.activeNavUrl = item.url;
      let url = item.url.replace('http://','//');
      let i = '',j='';
      let curPlatformInfo = this.platformList.find(e=>{
        return e.id == item.platformId;
      })
      let openType = "";
      if(curPlatformInfo.openNewWindow == 1){
        openType = '_blank';
      }else{
        openType = '_self';
      }
      if(url.indexOf('?') == -1){
        i = '?';
      }else{
        i = '&';
      }
      if(url.indexOf('id=') == -1){
        j = 'id=1&';
      }else{
        j = '';
      }
      url += (i + j + `from=${encodeURIComponent(item.url)}`);
      this.postMessage('getTopLocation');
      var apskMenuId = '';
      // 安排授课id正式37 测试11
      if(process.env.NODE_ENV=='development' || process.env.NODE_ENV=='testing'){
        apskMenuId = 11;
      }else if(process.env.NODE_ENV=='production'){
        apskMenuId = 37;
      }
      if(item.platformId == 2 && item.platformShopId == 20 && item.menuId == apskMenuId){
        // 19直播店铺安排授课链接跳转为新链接
        url = url.replace(/give-lessons/g,'give-lessons-nineteen');
      }
      if(top.location == self.location){
        window.open(url,openType);
      }else{
        if(curPlatformInfo.openNewWindow == 1){
          window.open(url,'_blank');
        }else{
          top.location.replace(url);
        }
      }
    },
    listenMessage(){
      let _this = this;
      // 设置监听  接收postMessage传递过来的数据
      window.addEventListener('message', function (e) {
        if(typeof e.data != 'string') return;
        const postData = JSON.parse(e.data);
        if(postData.type == 'setTopLocation'){
          _this.activeNavUrl = postData.url;
        }
      })
      // 检测断网
      window.addEventListener("offline", () => {
          console.log("已断网");
          this.network= false;
      });
      window.addEventListener("online", () => {
          console.log("网络已连接");
          this.network= true;
      });
    },
    postMessage(type){
      // 发送消息  通知message事件绑定完毕  load
      window.parent.postMessage(JSON.stringify({
        type:type
      }), '*');
    },

    // 设置预设导航
    setPresetConfig(config){
      this.saveUserConfig(config).then(res=>{
        console.log('设置预设导航成功');
      })
    },
    handleCancel() {
      this.showEditBox = false;
    },
    handleConfirm(newConfig) {
      this.showEditBox = false;
      this.saveUserConfig(newConfig).then(res=>{
      })
    },
    editNavName(config) {
      let _this = this;
      _this.postMessage('editNav');
      setTimeout(function(){
        _this.navConfig = config;
        _this.showEditBox = true;
      },300);
    },
    delNav(config){
      this.delUserConfig(config).then(res=>{
        this.showEditBox = false;
      })
    },
    quitSystem(){
      sso.ready().then(function (user) {
        //设置退出登录的点击事件
        user.logout();
      });
    }
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0,0,0,0.06);
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.08);
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(0,0,0,0.12);
  -webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.main-content {
  padding: 0;
  height: 100%;
}
.el-menu {
  border-right: none;
}
.row-bg {
  height: 100%;
  text-align: center;
}
.quit-system {
  cursor: pointer;
}
.collapse_menu {
  transition: all 0.1s cubic-bezier(0.25, 0.1, 0, 0.64);
  width: 49px !important;
  overflow: hidden;
  .main-title {
    font-size: 0;
    i {
      font-size: 16px;
      right: 16px;
    }
  }
  .my_collection {
    padding: 0 10px;
  }
  .collection_nav {
    p {
      width: 100%;
      padding: 0 10px;
    }
    p:hover {
      .menu_group {
        display: none;
      }
    }
  }
  .aside_menu {
    span {
    }
    span:first-of-type {
      font-size: 0;
      border-right: 0;
      i {
        font-size: 12px;
        margin-top: 3px;
      }
    }
    span:last-of-type {
      display: none;
    }
  }
}
aside {
  background-color: #001529;
  position: relative;
  overflow: hidden;
  .main-title {
    width: 100%;
    font-size: 16px;
    color: #fff;
    height: 60px;
    line-height: 60px;
    background: #00213f;
    font-weight: 700;
    text-align: left;
    padding-left: 20px;
    position: relative;
    span {
      color: red;
    }
    i {
      position: absolute;
      right: 10px;
      top: 22px;
      cursor: pointer;
    }
  }
  .my_collection {
    background: #00213f;
    margin: 0;
    color: #fff;
    padding-left: 20px;
    font-size: 14px;
    font-weight: 700;
    line-height: 40px;
    white-space: nowrap;
  }
  .collection_nav {
    height: calc(100% - 140px);
    overflow-y: scroll;
    p {
      height: 40px;
      margin: 0;
      padding: 0 20px;
      cursor: pointer;
      position: relative;
      .nav_text {
        width: 100%;
        display: inline-block;
        font-size: 14px;
        opacity: 0.8;
        line-height: 40px;
        color: #fff;
        overflow: hidden;
        white-space: nowrap;
      }
      .menu_group {
        color: #fff;
        position: absolute;
        right: 10px;
        top: 9px;
        display: none;
        i {
          cursor: pointer;
        }
      }
    }
    p:hover {
      background: #1f2638;
      span {
        display: inline-block;
        color: #fff;
      }
    }
    .active{
      span{
        color: #409eff;
      }
    }
  }
  .no_collection {
    p {
      font-size: 14px;
      color: #c8d1d6;
      line-height: 40px;
      text-align: center;
      margin: 0;
      padding-top: 25px;
    }
    .recommend_nav {
      text-align: center;
      div {
        font-size: 14px;
        color: #fff;
        border: 1px solid #fff;
        padding: 6px 15px;
        border-radius: 5px;
        margin-top: 20px;
        display: inline-block;
        cursor: pointer;
      }
    }
  }
  .network_error {
    padding-top: 200px;
    text-align: center;
    p {
      font-size: 14px;
      color: #c8d1d6;
      margin: 0;
    }
    span {
      font-size: 30px;
      color: #fff;
      margin-top: 10px;
      cursor: pointer;
    }
  }
  .aside_menu {
    width: 100%;
    height: 40px;
    background-color: #00213f;
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 0;
    padding: 11px 0;
    display: flex;
    justify-content: center;
    .collapse_btn{
      border-right: 1px solid #fff;
    }
    span {
      display: inline-block;
      width: 70px;
      line-height: 18px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.64);
      cursor: pointer;
    }
    span:last-of-type {
      i {
        transform: rotateZ(90deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue